/**
 * Sub-components for Estimates page — extracted from Estimates.jsx for maintainability.
 */
import React from "react";
import { CheckCircle2 } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";

export function CheckBox({ checked, onChange, label, testId }) {
  const { t } = useI18n();
  return (
    <button
      type="button"
      onClick={() => onChange(!checked)}
      data-testid={testId}
      className={`group flex items-center gap-2 px-3 py-2 rounded-lg border-2 text-sm font-medium transition-all min-h-[40px] text-left ${
        checked
          ? "bg-blue-50 border-blue-500 text-blue-900 shadow-sm"
          : "bg-white border-slate-200 text-slate-700 hover:border-blue-300 hover:bg-blue-50/40"
      }`}
    >
      <span
        className={`w-4 h-4 rounded border-2 flex items-center justify-center flex-shrink-0 transition-colors ${
          checked
            ? "bg-blue-600 border-blue-600 text-white"
            : "border-slate-300 group-hover:border-blue-400"
        }`}
      >
        {checked && <CheckCircle2 size={12} strokeWidth={3} />}
      </span>
      <span className="truncate">{t(label)}</span>
    </button>
  );
}

export function ChoiceGrid({ items, selected, onToggle, cols = 3, testIdPrefix }) {
  return (
    <div
      className={`grid gap-2 grid-cols-2 sm:grid-cols-3 ${
        cols >= 4 ? "md:grid-cols-4" : ""
      } ${cols >= 5 ? "lg:grid-cols-5" : ""}`}
    >
      {items.map((it) => (
        <CheckBox
          key={it.id}
          checked={(selected || []).includes(it.id)}
          onChange={(on) =>
            onToggle(
              on
                ? [...(selected || []), it.id]
                : (selected || []).filter((x) => x !== it.id),
            )
          }
          label={it.label}
          testId={`${testIdPrefix}-${it.id}`}
        />
      ))}
    </div>
  );
}

export function Section({ title, children }) {
  const { t } = useI18n();
  return (
    <div className="mb-5">
      <h3 className="text-xs font-bold uppercase tracking-wider text-blue-700 mb-2.5">
        {t(title)}
      </h3>
      {children}
    </div>
  );
}

export function YesNoGroup({ value, onChange, testIdPrefix }) {
  return (
    <div className="flex gap-2">
      <CheckBox
        checked={value === "yes"}
        onChange={(on) => onChange(on ? "yes" : null)}
        label="Sim"
        testId={`${testIdPrefix}-yes`}
      />
      <CheckBox
        checked={value === "no"}
        onChange={(on) => onChange(on ? "no" : null)}
        label="Não"
        testId={`${testIdPrefix}-no`}
      />
    </div>
  );
}

export const EMPTY_ESTIMATE = {
  name: "",
  phone: "",
  address: "",
  date: new Date().toISOString().slice(0, 10),
  prepared_by: "",
  pets: null,
  pet_names: "",
  home_types: [],
  home_type_other: "",
  bedrooms: "",
  bathrooms: "",
  square_footage: "",
  rooms: [],
  rooms_other: "",
  cleaning_types: [],
  cleaning_type_other: "",
  frequencies: [],
  frequency_other: "",
  preferred_days: [],
  preferred_times: [],
  provides_products: null,
  additional_services: [],
  rate_weekly: "",
  rate_bimonthly: "",
  rate_monthly: "",
  rate_other: "",
  key_instructions: "",
  status: "open",
  notes: "",
};
